<template>
  <a-modal
    title="Dodaj materiały dydaktyczne"
    width="40vw"
    wrapClassName="modal-wrapper"
    v-model="visible"
    @ok="onSubmit"
    @cancel="closeModal"
    okText="Zapisz"
    cancelText="Anuluj"
  >
    <form-wrapper
      ref="form"
      :service="Material"
      :formComponent="InnerForm"
      :form.sync="form"
      :errors.sync="errors"
      :objParams="objParams"
      class="form"
      @formSubmitted="success"
    />
  </a-modal>
</template>
<script>
import InnerForm from './InnerForm'
import { Material } from '@/api'

export default {
  data() {
    return {
      visible: false,
      objParams: null,
      form: {},
      errors: {},
      Material,
      InnerForm
    }
  },
  methods: {
    onSubmit() {
      this.$refs.form.onSubmit()
    },
    openModal({ courseId, instanceId, forWhom }) {
      if (instanceId) {
        this.objParams = instanceId
      } else {
        this.form = {
          course: courseId,
          for_whom: forWhom
        }
      }
      this.visible = true
    },
    success() {
      this.closeModal()
      this.$emit('formSubmitted')
    },
    closeModal() {
      this.resetForm()
      this.visible = false
    },
    resetForm() {
      this.objParams = null
      this.form = {}
      this.errors = {}
    }
  }
}
</script>

<style lang="scss" scoped>
.form {
  margin-bottom: -16px;
}
</style>
